export default __webpack_public_path__ + "static/media/riskfree.cf64dc33.svg";